import React from "react"
import {ReactComponent} from "../../app"
import {Button, Collapse, Image, Typography} from "antd"
import BottomSheet from "../layout/BottomSheet"

import arrowLeft from "../../gfx/arrow-left.svg"
import iconPhone from "../../gfx/icon-phone.svg"
import iconEmail from "../../gfx/icon-mail.svg"
import iconFacebook from "../../gfx/icon-facebook.svg"
import iconInstagram from "../../gfx/icon-ig.svg"
import iconGlobe from "../../gfx/icon-globe.svg"
import {RightOutlined} from "@ant-design/icons"

const ContactItem = ({ icon, href, text, isExternal }) => (
    <Typography.Link className="contact-item" href={href} target={isExternal ? "_blank" : undefined}>
      <div className="ta-center icon-wrapper">
        <Image preview={false} src={icon} />
      </div>
      {text}
    </Typography.Link>
)

const items = [
  {
    key: '1',
    label: 'LOBSTER Family restaurant',
    children: [
        <div key="address" className="contact-address">Galerie Šantovka, Polská 1, 779 Olomouc</div>,

        <ContactItem key="phone" icon={iconPhone} href="tel:+420730892286" text="+420 730 892 286" />,
        <ContactItem key="email" icon={iconEmail} href="mailto:lobster@lobster-restaurant.cz" text="lobster@lobster-restaurant.cz" />,
        <ContactItem key="facebook" icon={iconFacebook} href="https://www.facebook.com/lobster.santovka" text="lobster.santovka" isExternal />,
        <ContactItem key="instagram" icon={iconInstagram} href="https://www.instagram.com/lobster.restaurant" text="lobster.restaurant" isExternal />,
        <ContactItem key="website" icon={iconGlobe} href="https://www.lobster-restaurant.cz" text="www.lobster-restaurant.cz" isExternal />

    ]
  },
  {
    key: '2',
    label: 'LOBSTER Bistro',
    children: [
        <div key="address" className="contact-address">Galerie Šantovka, Polská 1, 779 Olomouc</div>,

        <ContactItem key="phone" icon={iconPhone} href="tel:+420730892288" text="+420 730 892 288" />,
        <ContactItem key="email" icon={iconEmail} href="mailto:bistro@lobster-bistro.cz, vrba@lobster-restaurant.cz" text="bistro@lobster-bistro.cz" />,
        <ContactItem key="facebook" icon={iconFacebook} href="https://www.facebook.com/bistrolobster" text="bistrolobster" isExternal />,
        <ContactItem key="instagram" icon={iconInstagram} href="https://www.instagram.com/bistrolobster" text="bistrolobster" isExternal />,
        <ContactItem key="website" icon={iconGlobe} href="https://www.lobster-bistro.cz" text="www.lobster-bistro.cz" isExternal />
    ]
  },
  {
    key: '3',
    label: 'BOWLAND Bowling center',
    children: [
        <div key="address" className="contact-address">Galerie Šantovka, Polská 1, 779 Olomouc</div>,

        <ContactItem key="phone" icon={iconPhone} href="tel:+420730892285" text="+420 730 892 285" />,
        <ContactItem key="email" icon={iconEmail} href="mailto:bowling@bowland-center.cz" text="bowling@bowland-center.cz" />,
        <ContactItem key="facebook" icon={iconFacebook} href="https://www.facebook.com/bowland.olomouc" text="bowland.olomouc" isExternal />,
        <ContactItem key="instagram" icon={iconInstagram} href="https://www.instagram.com/bowland_olomouc" text="bowland_olomouc" isExternal />,
        <ContactItem key="website" icon={iconGlobe} href="https://www.bowland-center.cz" text="www.bowland-center.cz" isExternal />
    ]
  }
]


export default class ContactDetail extends ReactComponent {
  render() {
    return (
      <BottomSheet
        active={this.props.active}
        onClose={this.props.onClose}
        overlay={true}
        iconClose={arrowLeft}
        content={
          <>
            <Collapse
              bordered={false}
              defaultActiveKey={['1']}
              items={items}
              accordion
              expandIconPosition="end"
              expandIcon={({ isActive }) => <RightOutlined style={{fontSize: "1.5em"}} rotate={isActive ? 90 : 180} />}
            />

            <div className="ta-center mt-3">
              <Button
                type="primary"
                href="https://www.google.com/maps/place/Galerie+%C5%A0antovka/@49.5871313,17.255117,17z/data=!3m1!4b1!4m6!3m5!1s0x47124e625037f99b:0xe9264ba71d69a85a!8m2!3d49.5871279!4d17.2576919!16s%2Fg%2F11b649bpbd?entry=ttu&g_ep=EgoyMDI1MDMyMy4wIKXMDSoASAFQAw%3D%3D"
                target="_blank"
                rel="noopener noreferrer"
                className="mb-3"
              >Zobrazit na mapě</Button>
            </div>
          </>
        }
      />
    )
  }
}